import ApolloClient from 'apollo-boost';
import * as queries from './queries';

export const client = new ApolloClient({
  uri:
    process.env.REACT_APP_CMS_ENDPOINT ||
    'https://us-central1-cms-test-3ff4b.cloudfunctions.net/cms/graphql'
});

export { queries };



// WEBPACK FOOTER //
// ./src/apollo/index.ts